<template>
  <div class="book_container">
    <!-- 头部标题 -->
    <van-nav-bar title="编辑附件产品规格书"
                 class="title">
      <img slot="left"
           class="img"
           src="@/assets/back.png"
           @click="$router.back()" />
    </van-nav-bar>
    <div class="pdf">
      <img src="@/assets/pdf.png"
           alt="必填"
           width="33px">
      <span>产品规格书</span>
      <img src="@/assets/dian.png"
           alt="必填"
           class="right">
    </div>
    <!-- 上传附件按钮 -->

    <div class="btn_box"><button class="btn">上传新附件</button></div>
  </div>
</template>

<script>
export default {
  name: 'book'
}
</script>

<style lang="less" scoped>
.book_container {
  color: #999;
  img {
    vertical-align: middle;
  }
  .title {
    height: 44px;
    background-color: #f3f3f3;
    color: #333;
    .img {
      width: 21px;
      height: 21px;
    }
  }
  .pdf {
    padding: 0 16px;
    position: relative;
    margin-top: 16px;

    .right {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 8px;
      right: 16px;
    }
  }
  .btn_box {
    position: absolute;
    bottom: 30px;
    padding: 0 12px;
    width: 100%;
    .btn {
      width: 93%;
      height: 40px;
      background-color: #f40442;
      color: #fff;
      border: 0;
      border-radius: 4px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/business/product/book.vue